import React from 'react';
import PropTypes from 'prop-types';

export default function GuessBadge({ email }) {
  // Handle cases where email is undefined, null, or empty string
  const displayLetter = email && email.length > 0 ? email.charAt(0).toUpperCase() : '?';

  return (
    <div
      style={{
        minWidth: 33,
        minHeight: 33,
        flexShrink: 0,
        color: '#000',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 18,
        boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
        outlineOffset: 4,
        isolation: 'isolate',
        fontWeight: 'bold'
      }}
    >
      {displayLetter}
    </div>
  );
}

GuessBadge.propTypes = {
  email: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/guess_badge.jsx